<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/administration" tag="li" class="breadcrumb-item"><a
                    href="">{{i18n('Administration')}}</a>
                </router-link>
                <router-link to="/roles" tag="li" class="breadcrumb-item"><a href="">{{i18n("Role users")}}</a>
                </router-link>
                <router-link to="/roles/form" tag="li" class="breadcrumb-item"><a href="">{{i18n("Create")}}</a>
                </router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl">
                <div class="row">
                    <div class="col-sm-9">
                        <h1 class="title">{{i18n("User Roles (Creation)")}}</h1>
                    </div>
                </div>
            </div>
            <div class="base_box_cnt" :class="{'fixed_header':fixed_header, 'border-bottom': fixed_header}">
                <div class="button-group">
                    <div class="row">
                        <div class="col-3">
                            <button type="button" @click="recordRoleToDB"
                                    class="btn base_btn solid_blue waves-effect waves-light">{{i18n('Save and close')}}
                            </button>
                        </div>
                        <div class="col-6" v-if="fixed_header">
                            <div class="form-inline">
                                <label class="col-form-label fs-12 mr-3">{{i18n("Title")}}:</label>
                                <input type="text" class="col-xl-9 col-lg-10 form-control base_input"
                                       :class="{'is-invalid': form.errors.has('name') }" v-model="role_name"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_ttl">
                    <div class="row">
                        <div class="col-xl-6 col-lg-12">
                            <div class="form-inline">
                                <label class="col-form-label fs-12 mr-3">{{i18n("Title")}}:</label>
                                <input type="text" class="col-xl-9 col-lg-10 form-control base_input"
                                       :class="{'is-invalid': form.errors.has('name') }" v-model="role_name"/>
                            </div>
                        </div>
                        <div class="col-xl-6 col-lg-12">
                            <div class="alert alert-danger fade in alert-dismissible show" role="alert"
                                 v-if="form.errors.has('permissions')">
                                {{i18n("Please select at least one permission")}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="base_box_cnt">
                    <div class="row" v-for="(part, part_key) in parts">
                        <div class="col-sm-4" v-for="(second_part, second_part_key) in part">
                            <ul class="list-unstyled checkbox-list">

                                <li class="head">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="second_part_key +'_'+ '_' +part_key"
                                               @change="permissionHeaderClicked(part_key, second_part_key)"
                                        >
                                        <label class="custom-control-label" :for="second_part_key +'_'+ '_' +part_key">
                                            <b>{{second_part.russian}}</b></label>
                                    </div>
                                </li>

                                <li v-for="(third_part, third_part_key) in second_part.permissions">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                               :id="third_part_key +'_'+second_part_key+'_'+part_key"
                                               :checked="hasPermissionId(third_part.id)"
                                               @change="permissionClicked(third_part.id)">
                                        <label class="custom-control-label"
                                               :for="third_part_key +'_'+second_part_key+'_'+part_key">{{third_part.name}}</label>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormService from "../../services/FormService";
    import FormInput from '../../components/FormInput';


    export default {
        components: {
            FormInput,
        },
        data() {
            return {
                form: new FormService({
                    name: null,
                    role_id: null,
                    permissions: [],
                }),
                status: 0,
                permissionsHeader: {
                    'locations': {
                        'name': 'locations',
                        'russian': this.i18n("Region"),
                        'permissions': [],
                    },
                    'stations': {
                        'name': 'stations',
                        'russian': this.i18n("Stations"),
                        'permissions': [],
                    },
                    'routes': {
                        'name': 'routes',
                        'russian': this.i18n("Routes"),
                        'permissions': [],
                    },
                    'schedules': {
                        'name': 'schedules',
                        'russian': this.i18n('Schedule'),
                        'permissions': [],
                    },
                    'tariffs': {
                        'name': 'tariffs',
                        'russian': this.i18n('Tariffs'),
                        'permissions': [],
                    },
                    'privileges': {
                        'name': 'privileges',
                        'russian': this.i18n('Privilege'),
                        'permissions': [],
                    },
                    'baggage': {
                        'name': 'baggage',
                        'russian': this.i18n('Baggage'),
                        'permissions': [],
                    },
                    'services': {
                        'name': 'services',
                        'russian': this.i18n("Services"),
                        'permissions': [],
                    },
                    'settings': {
                        'name': 'settings',
                        'russian': this.i18n('Settings'),
                        'permissions': [],
                    },
                    'return.services': {
                        'name': 'return.services',
                        'russian': this.i18n('Return service'),
                        'permissions': [],
                    },
                    'booking': {
                        'name': 'booking',
                        'russian': this.i18n('Booking'),
                        'permissions': [],
                    },
                    'transporters': {
                        'name': 'transporters',
                        'russian': this.i18n('Transporter'),
                        'permissions': [],
                    },
                    'buses': {
                        'name': 'buses',
                        'russian': this.i18n("Buses"),
                        'permissions': [],
                    },
                    'bus.types': {
                        'name': 'bus.types',
                        'russian': this.i18n('Bus type'),
                        'permissions': [],
                    },
                    'roles': {
                        'name': 'roles',
                        'russian': this.i18n('Roles'),
                        'permissions': [],
                    },
                    'users': {
                        'name': 'users',
                        'russian': this.i18n('Users'),
                        'permissions': [],
                    },
                    'cashiers': {
                        'name': 'cashiers',
                        'russian': this.i18n('Cashiers'),
                        'permissions': [],
                    },
                    /*'dispatcher': {
                        'name': 'dispatcher',
                        'russian': 'Отчетность диспетчеризации',
                        'permissions': [],
                    },
                    'transporter': {
                        'name': 'transporter',
                        'russian': 'Отчетность по перевозкам',
                        'permissions': [],
                    },
                    'sales': {
                        'name': 'sales',
                        'russian': 'Отчетность по продажам',
                        'permissions': [],
                    },*/
                    'trips': {
                        'russian': this.i18n('Trips'),
                        'name': 'trips',
                        'permissions': [],
                    },
                    'ticket': {
                        'russian': this.i18n('Tickets'),
                        'name': 'ticket',
                        'permissions': [],
                    },
                    'countries': {
                        'russian': this.i18n('Country'),
                        'name': 'countries',
                        'permissions': [],
                    },
                    'conductor': {
                        'russian': this.i18n('Conductor'),
                        'name': 'conductor',
                        'permissions': [],
                    },
                    'reports': {
                        'russian': this.i18n('Reports'),
                        'name': 'reports',
                        'permissions': [],
                    },
                    'dashboard': {
                        'russian': this.i18n('Dashboard'),
                        'name': 'dashboard',
                        'permissions': [],
                    },
                    'baggage-shipping': {
                        'russian': this.i18n('Baggage Shipping'),
                        'name': 'baggage-shipping',
                        'permissions': [],
                    },
                },
                permissions: {},
                permissionsMerge: [],
                blocks: [],
                parts: [],
                permission_ids: [],
                permission_headers: [],
                role_name: null,
                update: false,
                scrollTop: 0,
                role: {
                    role_name: '',
                    role_id: '',
                }
            }
        },
        methods: {
            getPermissions() {
                this.$api.get('access-control.roles.permissions')
                    .then(res => {
                        this.permissions = res.data;
                        this.mergePermissions();
                    });
            },
            mergePermissions() {
                for (let key in this.permissions) {

                    let permission_names = this.permissions[key].name.split('.');
                    let permission_names_length = permission_names.length;
                    let permission_key = permission_names[0];
                    let names = permission_names[0];
                    if (permission_names_length >= 3) {
                        for (let i = 1; i < permission_names_length - 1; i++) {
                            names = names + '.' + permission_names[i];
                        }
                        permission_key = names;
                    }
                    if (this.permissionsHeader[permission_key] && permission_key === this.permissionsHeader[permission_key].name) {
                        this.permissionsHeader[permission_key].permissions.push(this.permissions[key]);
                        if (permission_key === 'ticket') {
                            // console.log(this.permissionsHeader[permission_key]);
                        }
                    }
                }
                this.insertIntoBlocks();
            },
            insertIntoBlocks() {
                let counter = 0;
                let length = 0;
                let permissionsHeaderLength = Object.keys(this.permissionsHeader).length;

                for (let x in this.permissionsHeader) {
                    counter++;
                    length++;
                    this.blocks.push(this.permissionsHeader[x]);
                    if (counter === 3) {
                        this.parts.push(this.blocks);
                        this.blocks = [];
                        counter = 0;
                    } else if (counter !== 3 && length === permissionsHeaderLength) {
                        this.parts.push(this.blocks);
                    }
                }
            },
            permissionHeaderClicked(div_index, permission_header_index) {

                let header_and_div = div_index + '' + permission_header_index;

                this.form.errors.errors = [];
                let object = this.parts[div_index][permission_header_index].permissions;
                if (this.permission_headers.includes(header_and_div)) {
                    let permission_header = this.permission_headers.indexOf(header_and_div);
                    this.permission_headers.splice(permission_header, 1);
                    for (let index in object) {
                        if (this.permission_ids.includes(object[index].id)) {
                            let permission_index = this.permission_ids.indexOf(object[index].id);
                            this.permission_ids.splice(permission_index, 1);
                        }
                    }
                } else {
                    this.permission_headers.push(header_and_div);
                    for (let index in object) {
                        if (!this.permission_ids.includes(object[index].id)) {
                            this.permission_ids.push(object[index].id);
                        }
                    }
                }
            },
            permissionClicked(id) {
                this.form.errors.errors = [];
                if (this.permission_ids.includes(id)) {
                    let permission_index = this.permission_ids.indexOf(id);
                    this.permission_ids.splice(permission_index, 1);
                } else {
                    this.permission_ids.push(id);
                }
            },
            hasPermissionId(id) {
                return this.permission_ids.includes(id);
            },
            recordRoleToDB() {
                this.form.permissions = this.permission_ids;
                this.form.name = this.role_name;
                this.update ? this.updateRecord() : this.newRecord();
            },
            newRecord() {
                this.form.post('access-control.roles.store')
                    .then(res => {
                        if (!res.errors) {
                            this.$notify({
                                type: 'success',
                                group: 'foo',
                                title: 'Success',
                                text: this.i18n('Role has been saved successfully')
                            });
                            this.$router.push('/roles');
                        }
                    })
            },
            updateRecord() {
                let role = this.form.role_id;
                this.form.post('access-control.roles.update', role)
                    .then(res => {
                        if (!res.errors) {
                            this.$notify({
                                type: 'success',
                                group: 'foo',
                                title: 'Success',
                                text: this.i18n('Role has been saved successfully')
                            });
                            this.$router.push('/roles');
                        }
                    })
            },
            show(id) {
                this.$api.get('access-control.roles.show', id)
                    .then(response => {
                        this.role_name = response.data.role.name;
                        this.form.role_id = response.data.role.id;
                        this.permission_ids = response.data.permissions;
                    });
            }
        },
        created() {
            this.getPermissions();
            let role_id = this.$route.params.id;
            role_id ? this.show(role_id) : '';
            role_id ? this.update = true : false;
        },
        computed: {
            fixed_header() {
                return this.scrollTop > 92; // TODO: shu azgina xato ishlayapti.
            },
        },
        mounted() {
            window.addEventListener('scroll', (e) => {
                this.scrollTop = document.documentElement.scrollTop;
            });
        },
        watch: {
            role_name: function () {
                this.form.errors.errors = [];
            }
        }

    }
</script>


<style scoped>
    .fixed_header {
        position: fixed;
        top: 0;
        z-index: 111111111;
        background: white;
        right: 0;
        left: 300px;
    }
</style>
